import React from 'react'

type Props = {
  text: string | JSX.Element
  href?: string
  target?: '_self' | '_blank'
  type?: 'button' | 'submit' | 'reset'
  borderColor?: string
  bgColor?: string
  width?: string
  disabled?: boolean
  classes?: string
  onClick?: () => void
}

const Button = ({
  text,
  href,
  target = '_self',
  type = 'button',
  borderColor = 'border-basecolor',
  bgColor = 'bg-basecolor',
  width = 'w-11/12',
  disabled = false,
  classes,
  onClick,
}: Props) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      e.preventDefault()
      window.open(href, target, 'noopener')
    } else if (onClick) {
      onClick()
    }
  }

  return (
    <div className="text-center">
      <button
        type={type}
        name={type}
        disabled={disabled}
        className={`focus:outline-none rounded-full border-2 ${borderColor} ${bgColor} py-3 text-sm font-bold uppercase text-black ${width} ${
          disabled ? 'opacity-[0.2]' : ''
        } ${classes && classes}`}
        onClick={handleClick}
      >
        {text}
      </button>
    </div>
  )
}

export default Button
